import React from 'react';
import ParamsCard from '../../../components/Card/Params';
import { Shield, GitBranch, Calendar } from 'lucide-react';

const General = ({ frontendApp}) => {
  const params = [
    {
      title: 'App Name',
      value: frontendApp?.appName || '-',
      isCopy: true,
      icon: <Shield className="w-5 h-5 text-indigo-500" />,
    },
    {
      title: 'GitHub Repository',
      value: frontendApp?.gitHubRepo || '-',
      isCopy: true,
      icon: <GitBranch className="w-5 h-5 text-indigo-500" />,
    },
    {
      title: 'Created',
      value: frontendApp?.created || '-',
      icon: <Calendar className="w-5 h-5 text-indigo-500" />,
    }
  ];

  const handleOpenGitHub = () => {
    const repoUrl = `https://github.com/eduvanz-team/${frontendApp?.gitHubRepo || ''}`;
    window.open(repoUrl, '_blank');
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
      <div className="mb-5 border-b border-gray-100 pb-4 flex justify-between items-center">
        <h2 className="text-lg font-semibold text-gray-900">Application Details</h2>
        
        <button
          onClick={handleOpenGitHub}
          className="inline-flex items-center px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg transition-colors duration-200 font-medium shadow-sm text-sm"
        >
          <GitBranch className="h-4 w-4 mr-2" />
          View Repository
        </button>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {params.map((param, index) => (
          <ParamsCard
            key={index}
            title={param.title}
            value={param.value}
            isCopy={param.isCopy}
            icon={param.icon}
            description={param.description}
          />
        ))}
      </div>
    </div>
  );
};

export default General;